// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useEffect, useState} from 'react';
import {i_select_item} from '../../lib/select';
import etask from 'zetask';
// @ts-ignore
import {get_country_object} from '/util/country.js';
import {Flag} from '../../lib/flag';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import styles from './product_card.module.less';
import {Settings_context} from '../../settings_ctx';
import cn from 'classnames';

export const use_countries = (def_country:string, opt?: {
    flags?: boolean, css_styles?: any, separators?: boolean
})=>
{
    const with_flags = opt?.flags===false ? false : true;
    const with_separators = opt?.separators===false ? false : true;
    const styles_obj = opt?.css_styles || styles;
    const {theme, theme_name} = useContext(Settings_context);
    const [selected_country, set_selected_country] = useState(def_country);
    const [items, set_items] = useState<i_select_item[]>([]);
    useEffect(()=>{
        set_selected_country(def_country);
    }, [def_country]);
    useEffect(()=>{
        etask(function*(){
            let list;
            // @ts-ignore
            if (window.list_proxy_counties)
            {
                // @ts-ignore
                list = yield window.list_proxy_counties;
            }
            else
            {
                // @ts-ignore
                window.list_proxy_counties = fetch('/users/get_vpn_countries');
                // @ts-ignore
                list = yield window.list_proxy_counties;
            }
            const symbols = {};

            const list_with_top = ['us', 'uk']
              .map(c=>get_country_object(c));
            const sorted_and_as_objects = list.map(c=>get_country_object(c))
              .sort((a, b)=>(a.name_low as string).localeCompare(b.name_low));
            sorted_and_as_objects.forEach(c=>{
                if (c.code=='us' || c.code=='uk')
                    return;
                const f_s = c.name_low[0];
                if (!symbols[f_s] && with_separators)
                {
                    list_with_top.push(get_country_object(`separator_${f_s}`));
                    symbols[f_s] = 1;
                }
                list_with_top.push(c);
            });
            const def_arr = def_country=='some' && with_separators ? [{
                value: 'some',
                tags: 'some',
                title: <div className={cn(styles_obj.country_line)}>
                  {with_flags && <Flag
                    country={'all'}
                    size={20} round/>}
                  <p className={cn(theme.p3)}>Decide later</p>
                </div>,
                disabled: false,
            }] : [];
            set_items(def_arr.concat(list_with_top.map(c=>{
                if (c.name=='Croatia (Hrvatska)')
                  c.name = 'Croatia';
                return {
                    value: c.code,
                    tags: c.name_low,
                    title: c.code.indexOf('separator')>-1 ?
                      <div className={styles_obj.separator}>
                        <p className={cn(theme.p2, theme.bold)}>
                          {c.code.split('separator_')[1].toUpperCase()}
                        </p>
                      </div> :
                      <div className={cn(styles_obj.country_line)}>
                        {with_flags && <Flag
                          country={c.code=='uk' ? 'gb' : c.code}
                          size={20} round/>}
                        <p className={cn(theme.p3)}>{c.name}</p>
                      </div>,
                    disabled: c.code.indexOf('separator')>-1,
                };
            })));
        });
    }, [theme_name]);
    return {selected_country, set_selected_country, items};
};
